/**
 * @file 申诉
 * @author zhaomiaoyuan
 */
import React from 'react';
import secm from '@baidu/sec-monitor';
import {useHistory} from 'react-router-dom';

export default function QuestionPageTip() {
    const history = useHistory();

    const jump = (type) => {
        secm.action('feedback-tip', 'click', type);
        switch (type) {
            case 'occupy':
                history.push('/occupy');
                break;
            case 'appeal':
                history.push('/appeal');
                break;
            case 'mark':
                history.push('/mark?pagef=questionPageTip');
                break;
            case 'verify_msg':
                history.push('/verify_msg');
                break;
            default:
        }
    };
    return (<div className="feedback-text">
        <p>如需解决以下问题，请进入对应页面并提交信息：</p>
        <ul>
            <ol>· 号码被标记为骚扰等类型，可前往
                <span className="jump" onClick={() => jump('appeal')}>号码标记申诉</span>
                取消
            </ol>
            <ol>· 号码被企业/政府占用，可前往
                <span className="jump" onClick={() => jump('occupy')}>号码占用申诉</span>
                取消展示
            </ol>
            <ol>· 号码所属企业/政府信息变更，可前往
                <span className="jump" onClick={() => jump('verify_msg')}>认证信息修改</span>
                调整
            </ol>
            <ol>· 对骚扰、推销等号码进行标记，可前往
                <span className="jump" onClick={() => jump('mark')}>标记他人号码</span>

            </ol>
        </ul>
    </div>);
}